import {Product, ProductEvent} from '../../@types/wishlist.js';
import {ProductIdentifier} from '../service/product-identifier.js';
import {buildPdsUrl} from '../service/build-pds-url.js';

export class ProductEventAggregate {
  productIdentifier: ProductIdentifier;
  productName: string;
  brandName: string;
  colorName?: string;
  events: string[];
  campaigns: string;
  imageUrl: string;
  sizeOrQuantity?: string;
  isBeauty: boolean;
  brandCode: string;
  syan: number;
  colorId?: string;
  articleId?: string;
  salesInfoId?: string;
  pdsURL?: string;

  constructor(product: Product, productEvent: ProductEvent) {
    this.productIdentifier = ProductIdentifier.createByProduct(product);
    this.productName = product.name;
    this.brandName = product.brandName;
    if (product.isBeauty) {
      this.colorName = product.colorName;
    }
    this.events = productEvent.eventTypes;
    this.campaigns = productEvent.trackingCampaigns.join(',');
    this.isBeauty = product.isBeauty;
    this.brandCode = product.brandCode;
    this.syan = product.syan;
    this.colorId = product.colorId;

    const article = product.articles.find(a => a.id === product.articleId);
    if (article) {
      this.sizeOrQuantity = article.sizeOrQuantity;
      this.imageUrl = article.imageUrls[0].url;
      this.articleId = article.id;
      this.salesInfoId = article.salesInformationId;
    } else {
      this.imageUrl = product.defaultImageUrls[0].url;
    }
    // for tracking it is ok to hardcode the PROD host (cleared with PO)
    this.pdsURL = 'https://www.breuninger.com' + buildPdsUrl(product.pdsUrlBasePath, article?.id, product.colorId);
  }
}
